import $ from "jquery";
import ImageLightbox from "./lightbox.js";
import RatingManager from "./rating.js";

// Rating
$(function () {
  new RatingManager({ apiUrl: "/api/rating" });
});

// LightBox In initialization
document.addEventListener("DOMContentLoaded", () => {
  window.lightbox = new ImageLightbox({
    selector: ".rich-text img, .card img, img.zoomable"
  });
  window.lightbox.init();
});

// --- Sidebar ---
$(function () {
  // Open overlay
  document.querySelectorAll('.sidebar-icon').forEach(btn => {
    btn.addEventListener('click', () => {
      const target = document.querySelector(btn.dataset.target);
      if (target) {
        document.querySelectorAll('.sidebar-overlay').forEach(o => o.classList.remove('active'));
        target.classList.add('active');
      }
    });
  });

  document.querySelectorAll('.menu-item a').forEach(btn => {
    btn.addEventListener('click', e => {
      const targetSelector = btn.dataset.target;
      if (!targetSelector) {
        return;
      }

      // dataset.target is set → prevent anchor navigation
      e.preventDefault();

      const target = document.querySelector(targetSelector);
      if (!target) return; // guard if selector not found

      document.querySelectorAll('.sidebar-overlay')
        .forEach(o => o.classList.remove('active'));

      if (target) target.classList.add('active');
    });
  });

  // Back buttons
  document.querySelectorAll('.sidebar-overlay .back-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const overlay = btn.closest('.sidebar-overlay');
      const submenu = btn.closest('.overlay-submenu');
      if (submenu) {
        submenu.classList.remove('active');
        // overlay.querySelector('.overlay-menu').style.display = '';
      } else {
        overlay.classList.remove('active');
      }
    });
  });

  // Open submenus
  document.querySelectorAll('.menu-item').forEach(btn => {
    btn.addEventListener('click', () => {
      const target = document.querySelector(btn.dataset.target);
      const overlay = btn.closest('.sidebar-overlay');
      //overlay.querySelector('.overlay-menu').style.display = 'none';
      if (target) target.classList.add('active');
    });
  });
});

//--- Rolling banner ---
$(function () {
  //document.addEventListener("DOMContentLoaded", () => {
    let randomize = 0;

    const banner = document.querySelector(".banner");
    if (banner) {
      if (banner.dataset.randomize == "1") {
        randomize = 1;
      }
    }

    const punchlines = document.querySelectorAll(".punchline");
    const container = document.querySelector(".punchline-link-container");

    let currentIndex = -1;
    let intervalId = null;

    function showNextPunchline() {
      if (currentIndex >= 0) {
        punchlines[currentIndex].classList.remove("show");
      }

      currentIndex++;

      if (currentIndex >= punchlines.length) {
        currentIndex = 0;
      }

      const currentPunchline = punchlines[currentIndex];

      currentPunchline.classList.add("show");

      // Update link
      const url = currentPunchline.dataset.url;
      if (container && url) {
        const text = currentPunchline.dataset.text
        container.href = url;
        container.target = currentPunchline.target
        if (container.text) {
          container.innerText = text;
        }
      }
    }

    function showRandomPunchline() {
      // Hide current
      if (!punchlines) return;

      if (currentIndex >= 0) {
        punchlines[currentIndex].classList.remove("show");
      }

      // Pick new
      let newIndex;
      do {
        newIndex = Math.floor(Math.random() * punchlines.length);
      } while (newIndex === currentIndex);

      currentIndex = newIndex;
      const currentPunchline = punchlines[currentIndex];

      currentPunchline.classList.add("show");

      // Update link
      const url = currentPunchline.dataset.url;
      if (container && url) {
        const text = currentPunchline.dataset.text
        container.href = url;
        container.target = currentPunchline.target
        if (container.text) {
          container.innerText = text;
        }
      }
    }

    function startRotation() {
      if (!punchlines || punchlines.length == 1) return;

      if (!intervalId) {
        intervalId = setInterval(randomize == 1 ? showRandomPunchline : showNextPunchline, 4000);
      }
    }

    function stopRotation() {
      if (intervalId) {
        clearInterval(intervalId);
        intervalId = null;
      }
    }

    // Hover behavior = pause / resume
    if (container) {
      container.addEventListener("mouseenter", stopRotation);
      container.addEventListener("mouseleave", startRotation);
    }

    // Init
    randomize = 1 ? showRandomPunchline() : showNextPunchline();
    startRotation();
 // });

  //----
  document.querySelectorAll('.punchline .scale p').forEach(p => {
    function fitText() {
      const parent = p.parentElement;

      let min = 7;
      let max = 35;
      let bestSize = min;
      const maxLines = 4;

      while (min <= max) {
        const size = Math.floor((min + max) / 2);
        p.style.fontSize = size + 'px';

        const fits =
          p.scrollHeight <= parent.clientHeight &&
          p.scrollWidth <= parent.clientWidth;

        const lineHeight = parseFloat(getComputedStyle(p).lineHeight);
        const lines = Math.round(p.scrollHeight / lineHeight);

        if (fits && lines <= maxLines) {
          bestSize = size;
          min = size + 1; // try bigger
        } else {
          max = size - 1; // too big
        }
      }

      p.style.fontSize = bestSize + 'px';
    }

    fitText();

    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(fitText, 100);
    });

  });


  document.querySelectorAll('.punchline').forEach(scale => {
    return;
    const content = scale.querySelector('.scale');
    if (!content) return;

    function applyScale() {
      content.style.transform = 'scale(1)';

      const contentRect = content.getBoundingClientRect();
      const parentRect = scale.getBoundingClientRect();

      const factor = Math.min(
        parentRect.width / contentRect.width,
        parentRect.height / contentRect.height
      );

      content.style.transform = `scale(${factor})`;
    }

    applyScale();

    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(applyScale, 100);
    });

  });
});

//--- Form Implementation. Transform form to Querystring ---
$(function () {
  document.querySelectorAll('form').forEach(form => {
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      const params = new URLSearchParams();

      // serialize text, hidden, select inputs
      form.querySelectorAll('input[type="text"], input[type="hidden"], select').forEach(el => {
        if (el.value) params.set(el.name, el.value);
      });

      // serialize all multi-checkboxes as CSV automatically
      const checkboxGroups = {};
      form.querySelectorAll('input[type="checkbox"]:checked').forEach(cb => {
        if (!checkboxGroups[cb.name]) checkboxGroups[cb.name] = [];
        checkboxGroups[cb.name].push(cb.value);
      });

      for (const [name, values] of Object.entries(checkboxGroups)) {
        params.set(name, values.join(','));
      }

      // redirect or ajax
      const url = `${form.action}?${params.toString()}`;
      window.location.href = url;
    });
  });
});

//--- Slicker Implementation ---
$(function () {

  /// Equalize card heights within a slider
  function equalize($slider) {
    if (!$slider || !$slider.length) return;

    // select only original slides (skip clones)
    //const $cards = $slider.find(".slick-slide:not(.slick-cloned) .card, > .card");
    const $cards = $slider.find(".slick-slide .card, > .card");
    if (!$cards.length) return;

    // reset heights first
    $cards.parent().css("height", "auto");

    // find max height
    let max = 0;
    $cards.each(function () {
      const h = $(this).outerHeight();
      if (h > max) max = h;
    });

    // apply max height to all cards
    $cards.parent().css("height", max + "px");
  }

  // Equalize all sliders on the page
  function equalizeAll() {
    $(".slicker").each(function () {
      equalize($(this));
    });
  }

  // Debounced resize handler
  let resizeTimer;
  $(window).on("resize orientationchange", function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(equalizeAll, 100);
  });

  // Initialize each slider
  $(".slicker").each(function () {
    const $slider = $(this);

    // Read slides config from data attribute
    const slides = $slider.data("slides");
    const slideArray = (slides && slides.trim())
      ? slides.split(',').map(x => parseInt(x.trim(), 10))
      : [4, 3, 2, 1];

    // Initialize slick
    $slider.slick({
      slidesToShow: slideArray[0],
      slidesToScroll: 1,
      infinite: true,
      adaptiveHeight: false,
      responsive: [
        { breakpoint: 992, settings: { slidesToShow: slideArray[1] } },
        { breakpoint: 768, settings: { slidesToShow: slideArray[2] } },
        { breakpoint: 576, settings: { slidesToShow: slideArray[3] } }
      ]
    });

    // Slick events
    $slider.on("init reInit setPosition afterChange", function () {
      equalize($slider);
    });

    // Equalize once after initialization
    setTimeout(function () { equalize($slider); }, 0);

    // Re-equalize when images finish loading
    $slider.find("img").each(function () {
      if (!this.complete) {
        $(this).one("load error", function () { equalize($slider); });
      }
    });
  });

  $('.slider-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.slider-nav'
  });
  $('.slider-nav').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '.slider-for',
    dots: false,
    centerMode: false,
    focusOnSelect: true
  });
});
